import * as THREE from "three";

/**
 * This abstracts away how Three builds
 * materials, and provides a simpler API
 * related to how a colors data is shaped
 *
 */
export function getMaterial({
  color = "f1f1f1",
  shininess = 10,
  texture = null,
  metallic = false,
  roughness = 0,
  size = [1, 1, 1]
}) {
  let material;

  // Metallic
  if (metallic) {
    var loader = new THREE.CubeTextureLoader();
    loader.setPath("../../public/textures/cube/");

    var textureCube = loader.load([
      "px.png",
      "nx.png",
      "py.png",
      "ny.png",
      "pz.png",
      "nz.png"
    ]);

    material = new THREE.MeshStandardMaterial({
      color: color, //parseInt("0x" + color, 16),
      envMap: textureCube,
      envMapIntensity: 1.5,
      metalness: 1,
      roughness: roughness
    });
  }
  // Textured
  else if (texture) {
    let texture_image = new THREE.TextureLoader().load(texture);

    let colorSize =
      typeof size === "string" ? size.split(",").map(Number) : size;

    // texture_image.repeat.set(colorSize[0], colorSize[1], colorSize[2]);
    // texture_image.rotation = Math.PI / 2;

    texture_image.wrapS = THREE.RepeatWrapping;
    texture_image.wrapT = THREE.RepeatWrapping;

    texture_image.flipY = false;

    material = new THREE.MeshStandardMaterial({
      map: texture_image,
      shininess: shininess ? shininess : 10,
      morphTargets: true,
      transparent: true
    });
  }
  // Standard Non-Metallic
  else {
    material = new THREE.MeshPhongMaterial({
      color: color,
      shininess: parseInt(shininess)
    });
  }

  // console.log(material);
  return material;
}

/**
 * This takes an array in a string
 * and fixes it, its a helper related
 * to the way WordPress hands over
 * a color array.
 *
 */
export function stringArraytoArray(str) {
  let array = str
    .replace(/[\[\]']+/g, "")
    .replace(/['"]+/g, "")
    .split(",");
  return array;
}

/**
 * A helper to turn a string like
 * '#someElement' or '.mycontainer'
 * into a dom element with the correct
 * attribute on the element set
 *
 * If its not valid, it falls back to a
 * default
 *
 */

export function stringToNode(str, fallback) {
  let node = document.createElement("div");

  str.charAt(0) === "#"
    ? (node.id = str.substring(1))
    : str.charAt(0) === "."
    ? node.classList.add(str.substring(1))
    : (node.className = fallback.substring(1));

  return node;
}

export function round(value, decimals) {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
}
